import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.submitted = false
    this.originalButtonHtml = this.buttonTarget.innerHTML
  }

  start(event) {
    if (this.submitted) {
      event.preventDefault()
      return
    }

    this.submitted = true
    this.buttonTarget.disabled = true
    this.buttonTarget.setAttribute("aria-busy", "true")
    this.buttonTarget.innerHTML = this.loadingHtml()
  }

  finish(event) {
    if (event.detail.success) return

    this.submitted = false
    this.buttonTarget.disabled = false
    this.buttonTarget.removeAttribute("aria-busy")
    this.buttonTarget.innerHTML = this.originalButtonHtml
  }

  loadingHtml() {
    return `<svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
    </svg><span>Gerando PDF Consolidado...</span>`
  }
}
